import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'
import { reflection, background } from './sierras.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/220520/Ltd Editions/sierras-le_ln4/sierras-le_ln4_{nnn}.png',
}

export default {
  layers: [background, body, reflection],
  resolveOptions: () => ({
    reflections: 'none',
  }),
}
